// extracted by mini-css-extract-plugin
export default {"heading":"previewTemplate_heading__5KSAH","schedulerBorder":"previewTemplate_schedulerBorder__RpvJ8","interview":"previewTemplate_interview__JuBiI"};